import { addIndividualPersonalnfo, addAssociate, noteModel, directorModel, WatchListModel, existingAssociates } from './../model/record.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { addOrganizationModel } from '../model/record.model';
import { addUser, verifyLogin } from '../model/user.model';
import { BaseUrlService } from './base-url.service';

@Injectable({
  providedIn: 'root'
})
export class RecordManagementService {

  constructor( private http: HttpClient, private base:BaseUrlService ) { }

  private userUrl = this.base._userUrl;

  addOrganizationPersonalInfo(payload: addOrganizationModel, postedBy):Observable<addOrganizationModel>{
    return this.http.post<any>(this.userUrl + 
      `/record/info/organization/add_update/${postedBy}`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  addIndividualPersonalInfo(payload: addIndividualPersonalnfo, postedBy):Observable<addIndividualPersonalnfo>{
    return this.http.post<any>(this.userUrl + 
      `/record/info/personal/add_update/${postedBy}`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  addDirector(payload: directorModel[], recordid,postedBy):Observable<directorModel[]>{
    return this.http.post<any>(this.userUrl + 
      `/record/director/add/${recordid}?postedby=${postedBy}`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  

  recordAssociateList(recordid: number, requestedby: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/associate/list?recordid=${recordid}&requestedby=${requestedby}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }

  deletRecord(category: string, recordid: number, requestedby: number){
    return this.http.delete<any>(this.userUrl + `/record/delete?category=${category}&recordid=${recordid}&requestby=${requestedby}`)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  deleteNotes(recordid: number, postedby: number, noteid: number){
    return this.http.delete<any>(this.userUrl + `/record/notes/${recordid}?noteid=${noteid}&postedby=${postedby}`)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  deleteAssociate(category: string, recordid: number, requestedby: number){
    return this.http.delete<any>(this.userUrl + `/record/associate/${recordid}?postedby=${requestedby}`)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  
  deleteDirectors(id: number, recordid: number, postedby: number){
    return this.http.delete<any>(this.userUrl + `/record/director/delete/${id}?postedby=${postedby}&recordid=${recordid}`)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  

  addAssociateApi(payload: addAssociate):Observable<addAssociate>{
    return this.http.post<any>(this.userUrl + 
      `/record/associate/add`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  addNotes(payload: noteModel, postedBy: number):Observable<noteModel>{
    return this.http.post<any>(this.userUrl + 
      `/record/notes/${postedBy}`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  getRecordDetails( userid: number,category:string, recordid: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/retrieve/${recordid}?category=${category}&postedby=${userid}`)
      .pipe(
        catchError(err => this.errorHandler(err))
      )
    }

    getDirectors( postedby: number, recordid: number): Observable<any>{
      return this.http.get<any>(this.userUrl +
        `/record/director/list?postedby=${postedby}&recordid=${recordid}`)
      .pipe(
        catchError(err => this.errorHandler(err))
      )
    }
    
  addExistingAssociateApi(payload: existingAssociates):Observable<existingAssociates>{
    return this.http.post<any>(this.userUrl + 
      `/record/associate/link`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
    

    getNotes( userid: number, recordid: number, category: string): Observable<any>{
      //change get notes url too
      return this.http.get<any>(this.userUrl +
        `/record/notes/${recordid}?category=${category}&postedby=${userid}`)
        .pipe(
          catchError(err => this.errorHandler(err))
        )
      }

  recordInfoListOrganization(page: number, requestedby: number, size: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/info/list/organization?page=${page}&requestedby=${requestedby}&size=${size}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }
  
  recordInfoListPersonal(page: number, requestedby: number, size: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/info/list/personal?page=${page}&requestedby=${requestedby}&size=${size}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }

  recordRetrieve(postedby: number, recordid: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/retrieve/${recordid}?postedby=${postedby}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }

  recordList(category: string, page: number, requestedby: number, size: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/list?category=${category}&page=${page}&requestedby=${requestedby}&size=${size}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }

  changeWatchList(payload: WatchListModel):Observable<WatchListModel>{
    return this.http.post<any>(this.userUrl + 
      `/record/watchlist/update`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  } 

  getRecordList( clientid: string, page: number, size: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/list/all?page=${page}&requestby=${clientid}&size=${size}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }
   getAssociates( userid: number, recordId: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/record/associate/list?recordid=${recordId}&requestby=${userid}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }


  errorHandler(error:HttpErrorResponse){
    return throwError(error.message || "Server Error") 
  }


}
